import React, { useRef } from "react";

import { Paper, Typography, Box } from "@mui/material";
import AutoDetect from "./Timestamp/DetectTimestamp";
import ReactPlayer from "react-player";

const VideoDetail = ({ video }) => {
  if (!video) {
    return (
      <Box className="loading">
        <Typography variant="h4" gutterBottom>
          Search for a video to get started
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Pick something you want to watch and the player will show up here.
        </Typography>
      </Box>
    );
  }
  const videoId = typeof video.id === "string" ? video.id : video.id?.videoId;
  const videoSrc = `https://www.youtube.com/watch?v=${videoId}`;
  const player = useRef(null);

  return (
    <React.Fragment>
      <Paper>
        <div className="player-wrapper">
          <ReactPlayer
            width="100%"
            height="100%"
            ref={player}
            src={videoSrc}
            controls={true}
            playing={true}
            // autoPlay={true}
            // config
            className="react-player"
          ></ReactPlayer>
        </div>
        <Box style={{ padding: "5px" }}>
          <Typography variant="h5">
            {video.snippet.title} - {video.snippet.channelTitle}
          </Typography>
          <Typography variant="subtitle1">
            {video.snippet.channelTitle}
          </Typography>
          <Box>
            <AutoDetect video={video} player={player}></AutoDetect>
          </Box>
        </Box>
      </Paper>
    </React.Fragment>
  );
};

export default VideoDetail;
